<template>
    <div class="perex">
        <div v-if="banners.length" class="perex__banner">
            <ObjectsSubcategoryTileBanner :banner="banners[bannerIndex]" />
        </div>

        <div class="title-container">
            <h1 id="main-title" class="mb-3 h2" data-cy="main-title">
                {{ title }}
            </h1>
        </div>
        <div v-if="showOutfindoCatalogGuide" id="outfindo-catalog-guide"></div>

        <!--        && !isSaleAndDiscountCategory-->

        <div v-if="seoPerexText || perexText || richContentWidgets.length > 0" class="perex__text">
            <TruncatedText
                class="service-detail__shortdesc"
                :is-desktop="$device.isDesktop"
                :text="perexText"
                :seo-perex="seoPerexText"
                :rich-content-widgets="richContentWidgets"
                :limit="80"
                :limit-desktop="250"
                :show-more-scroll-to-element="showMoreScrollToElement"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import TruncatedText from '~/components/elements/TruncatedText.vue'
import Widget from '~/models/StaticContent/Widget'
import { useServerSideData } from '~/stores/serverSideData'

interface Props {
    richContentWidgets?: Widget[]
    perexText: string
    seoPerexText?: string
    title: string
    banners: any[]
    count?: string
    showMoreScrollToElement?: string
}

const props = withDefaults(defineProps<Props>(), {
    richContentWidgets: () => [],
    seoPerexText: '',
    count: '',
    showMoreScrollToElement: '',
})

const serverSideData = useServerSideData()
if (process.server) {
    serverSideData.setListSubCategoriesBannerIndex(randomIndex())
}
const index = serverSideData.listSubCategoriesBannerIndex
const bannerIndex = ref(index < props.banners.length - 1 ? index : randomIndex())
function randomIndex() {
    return 0
    // return Math.floor(Math.random() * props.banners.length)
}

const showOutfindoCatalogGuide = computed(() => {
    return useRoute().fullPath.startsWith('/doplnky-stravy?') || useRoute().fullPath.endsWith('/doplnky-stravy')
})
</script>

<style lang="scss" scoped>
@import '../../node_modules/bootstrap/scss/functions';
@import '../../node_modules/bootstrap/scss/variables';
@import '../../node_modules/bootstrap/scss/mixins';

.perex__banner {
    margin: 0 0 15px 0;

    @include screen-md {
        float: right;
        max-width: 640px;
        margin: 0 0 15px 30px;
    }
}

.perex {
    @include clearfix;

    //.banner {
    //    display: flex;
    //    overflow: hidden;
    //    position: relative;
    //    min-height: 144px;
    //    background-position: top right;
    //    background-repeat: no-repeat;
    //    text-decoration: none;
    //    color: inherit;
    //
    //    &::after {
    //        content: '';
    //        position: absolute;
    //        z-index: 1;
    //        top: 0;
    //        left: 0;
    //        width: 100px;
    //        height: 100%;
    //        background-color: $color-white;
    //        box-shadow: 0 0 45px 100px $color-white;
    //    }
    //
    //    @include media-breakpoint-up(md) {
    //        flex-direction: column;
    //    }
    //
    //    @include media-breakpoint-down(sm) {
    //        align-items: flex-end;
    //
    //        &::after {
    //            top: auto;
    //            bottom: 0;
    //            width: 100%;
    //            height: 0;
    //            background-color: $color-white;
    //            box-shadow: 0 0 60px 90px $color-white;
    //        }
    //    }
    //
    //    &__text {
    //        flex: 1;
    //        display: flex;
    //        flex-direction: column;
    //        justify-content: space-between;
    //        align-items: baseline;
    //        position: relative;
    //        z-index: 2;
    //
    //        p {
    //            flex: 1;
    //        }
    //    }
    //}

    &__text {
        font-size: 16px;
        margin-bottom: 20px;

        span > p {
            display: inline-block;
            margin-bottom: 1em;
        }
    }
    .count {
        font-size: 14px;
        white-space: nowrap;
        font-weight: normal;
        color: #424242;
        padding-left: 8px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
            'Helvetica Neue', sans-serif;
        font-variation-settings: 'wght' 400, 'wdth' 100;
    }

    .title-container {
        padding-top: 10px;

        h1 {
            font-size: 28px;
            display: block;
            font-family: 'scale-variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
                'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
            font-variation-settings: 'wght' 700, 'wdth' 130;
            color: $color-primary-green;

            @include screen-md {
                font-size: 44px;
            }
        }
    }
}
</style>
